import React from "react";
import { Navigate } from "react-router-dom";
import TokenManager from "storage/TokenManager";
import { pageRoutes } from "./index";
import Unauthorized from "components/Unauthorized";
import PropTypes from "prop-types";
import withRouter from "utils/withRouter";

/*
 Guard rendered through the v6 Route element prop. The withRouter shim
 supplies the v5-shaped location/history/match props that the routed
 class components still consume.
*/
const DEFAULT_COMPONENT_PROPS = {};

function RouteGuard({
  component: Component,
  isPrivate = false,
  isAuthorized = true,
  viewOnly = false,
  componentProps = DEFAULT_COMPONENT_PROPS,
  ...routerProps
}) {
  const isSignedIn = TokenManager.isAuthenticated();

  if (isPrivate && !isSignedIn) {
    return <Navigate to={pageRoutes.login.path} replace />;
  }

  if (!isAuthorized) {
    return <Unauthorized />;
  }

  return <Component viewOnly={viewOnly} {...routerProps} {...componentProps} />;
}

RouteGuard.propTypes = {
  /**
    Determines if the route requires authentication or not.
  */
  isPrivate: PropTypes.bool,
  /**
    Determines if the route is accessible by the signed in user or not.
  */
  isAuthorized: PropTypes.bool,
  /**
    Determines if the component loaded can be edited or not (ie. Table values)
  */
  viewOnly: PropTypes.bool,
  /**
    The component that is loaded when this route is called successfully.
  */
  component: PropTypes.elementType,
  /**
    The props that the component requires.
  */
  componentProps: PropTypes.object,
};

export default withRouter(RouteGuard);
